export const MESSAGE_TRANSLATE = 'MESSAGE_TRANSLATE'
export const STREAM_TRANSLATE = 'STREAM_TRANSLATE'
export const SITE_TRANSLATE = 'SITE_TRANSLATE'
export const FETCH_LANGUAGE_PREFERENCES = 'FETCH_LANGUAGE_PREFERENCES'